import { useEffect, useRef } from 'react'
import { APP_COOKIEBOT_URL_TEXTS } from 'src/config'

export default function CookiePolicy(): JSX.Element {
  const legalContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = APP_COOKIEBOT_URL_TEXTS
    script.type = 'text/javascript'
    script.async = true
    script.type = 'text/javascript'

    legalContainerRef.current?.appendChild(script)

    return () => {
      legalContainerRef.current?.removeChild(script)
    }
  }, [])

  return (
    <div style={{ paddingTop: 16, paddingBottom: 16 }}>
      <div ref={legalContainerRef} id="CookieDeclaration" />
    </div>
  )
}
